var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useParams } from 'react-router';
import { Loader } from 'src/ui/components/Loader/Loader';
import { useMount } from 'src/shared/hooks/useLifecycle';
import { E_SSE_CHANNELS, SSE_ENDPOINT } from 'src/services/constants';
import { StreamEntity } from 'src/shared/StreamEntity';
import { Error } from 'src/ui/views/caseDetails/errors/Error';
import { getLocalStorage, saveInLocalStorage } from 'src/shared/helpers/storageHelpers';
import { onTabClose } from 'src/shared/helpers/browserHelpers';
import { removeStreamFromStorage } from 'src/ui/views/caseDetails/helpers';
import { StreamOverflow } from 'src/ui/views/caseDetails/errors/StreamOverflow/StreamOverflow';
import { useCaseAutoPlayRedirect } from 'src/ui/views/caseDetails/hooks';
import DynamicsView, { E_DYNAMICS_VIEW_KEYS } from '../dynamics';
import styles from './caseDetails.module.scss';
export var CaseDetails = function (props) {
    var i18n = props.i18n, realm = props.realm, currentCase = props.currentCase, isCaseLoading = props.isCaseLoading, isCommentDisplayed = props.isCommentDisplayed, updateTemplate = props.updateTemplate, fetchCaseDetails = props.fetchCaseDetails, updateCurrentCaseHistory = props.updateCurrentCaseHistory, updateCurrentCaseComment = props.updateCurrentCaseComment, clearCurrentCase = props.clearCurrentCase, updateCaseIsLoading = props.updateCaseIsLoading, autoPlay = props.autoPlay, applicants = props.applicants;
    var productInfo = useParams().productInfo;
    var urlProductInfoSplit = (productInfo === null || productInfo === void 0 ? void 0 : productInfo.split(':')) || [];
    var _a = urlProductInfoSplit.length > 1 ? urlProductInfoSplit : [null, urlProductInfoSplit[0]], product = _a[0], token = _a[1];
    var _b = useState(null), viewKey = _b[0], setViewKey = _b[1];
    var _c = useState(false), isTooManyOpened = _c[0], setIsTooManyOpened = _c[1];
    useCaseAutoPlayRedirect(token, autoPlay, isCaseLoading, applicants, currentCase);
    useMount(function () {
        var _a;
        updateCaseIsLoading(true);
        // Omit because stream object can't be store in to local storage
        var streamRunningStored = ((_a = getLocalStorage()) === null || _a === void 0 ? void 0 : _a.streamRunning) || [];
        var isTooMuchStreamOpened = streamRunningStored.length >= 5;
        var stream = new StreamEntity(SSE_ENDPOINT.CASE_DETAILS(realm, token));
        var channels = [
            {
                channel: E_SSE_CHANNELS.PAGE,
                eventListener: onPageEvents,
                params: { nbOfMsg: 1 },
            },
            {
                channel: E_SSE_CHANNELS.UPDATES,
                eventListener: onUpdateEvents,
            },
            {
                channel: E_SSE_CHANNELS.HISTORY,
                eventListener: onHistoryEvents,
                params: { nbOfMsg: 300 },
            },
        ];
        if (isCommentDisplayed) {
            channels.push({
                channel: E_SSE_CHANNELS.INTERNAL_COMMENTS,
                eventListener: onInternalCommentEvents,
                params: { nbOfMsg: 100 },
            });
        }
        stream.addListenerChannel(channels);
        if (isTooMuchStreamOpened) {
            setIsTooManyOpened(true);
        }
        else {
            stream.openSSE();
            saveInLocalStorage({ streamRunning: __spreadArray(__spreadArray([], streamRunningStored, true), StreamEntity.streamRunning, true) });
            fetchCaseDetails(token);
            onTabClose(removeStreamFromStorage);
            return function () {
                removeStreamFromStorage();
                stream.stopSSE();
                clearCurrentCase();
            };
        }
    });
    var ViewContainer = DynamicsView(viewKey || E_DYNAMICS_VIEW_KEYS.CASE_GLOBAL_VIEW_PAGE);
    var onPageEvents = function (response) {
        console.info('%cSSE triggered page event', 'color: #4AAD52', response);
        var headers = response.headers, body = response.body;
        var TaskName = headers.TaskName;
        var options = body.options;
        updateTemplate(options, token);
        setViewKey(TaskName);
    };
    var onUpdateEvents = function (response) {
        console.info('%cSSE triggered update event', 'color: #4AAD52', response);
        fetchCaseDetails(token);
    };
    var onHistoryEvents = function (response) {
        console.info('%cSSE triggered history event', 'color: #4AAD52');
        updateCurrentCaseHistory(response);
    };
    var onInternalCommentEvents = function (response) {
        console.info('%cSSE triggered comment event', 'color: #4AAD52');
        updateCurrentCaseComment(response);
    };
    if (isTooManyOpened) {
        return _jsx(StreamOverflow, { i18n: i18n });
    }
    if (!isCaseLoading && (!viewKey || !currentCase)) {
        return _jsx(Error, { i18n: i18n, token: token });
    }
    return (_jsx("section", __assign({ className: styles.caseDetailsWrapper }, { children: isCaseLoading ? _jsx(Loader, {}) : _jsx(ViewContainer, { productToken: token, product: product }) })));
};
